﻿const cartHandler = {
    optionFinanced: '',
    totalPriceCashFormatted: '',
    totalSpecialFeeFormatted: '',
    isAllOrderLinesAccessory: false,
    hasAtLeastOneProductWithEnvironmentalReturn: false,
    hasChosenEnvironmentalReturn: false,
    isDone: false,
    deliveryType: {},
    insurance: {},
    loading: false,
    cartEmpty: false,
    financedResult: {},
    maxAmountExceeded: false,
    productAdded: false,
    address: {},
    orderlines: [],
    accessories:[],
    salesMode: false,
    isSalesCase: false,
    environmentalReturn: {},
    firstName: '',
    lastName: '',
    email: '',
    phone: '',

    async getCart() {
        this.loading = true;

        // Check if user comes from Sales site
        let isSales = window.cookie.get('sales_case');
        if (isSales) {
            this.isSalesCase = true;
        } else {
            this.isSalesCase = false;
        }

        try {
            const response = await fetch(`/umbraco/surface/cartsurface/GetCart`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    ...window.getVerificationToken()
                },
            });

            if (response.status === 200) {
                const data = await response.json();
                this.transformCart(data);
            } else {
                console.log('No data')
            }
        } catch (error) {
            console.log(error)
        } finally {
            this.loading = false;
            this.isDone = true;
        }
    },
    async deleteOrderline(orderlineId) {
        this.loading = true;
        console.log(orderlineId)

        try {
            this.productAdded = false;
            const response = await fetch(`/umbraco/surface/cartsurface/RemoveOrderline`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...window.getVerificationToken()
                },
                body: JSON.stringify({
                    orderLineId: orderlineId
                }),
            });

            if (response.status === 200) {
                const data = await response.json();
                this.transformCart(data);

            } else {
                console.log('No data')
            }
        } catch (error) {
            console.log(error)
        } finally {
            this.loading = false;
            this.isDone = true;
        }
    },
    async updateInsurance(orderlineId, val) {
        this.loading = true;

        try {
            this.productAdded = false;
            const response = await fetch(`/umbraco/surface/cartsurface/UpdateInsurance`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...window.getVerificationToken()
                },
                body: JSON.stringify({
                    orderLineId: orderlineId,
                    hasInsurance: val,
                }),
            });

            if (response.status === 200) {
                const data = await response.json();
                this.transformCart(data);
            } else {
                console.log('Failed');
            }
        } catch (error) {
            console.log(error)
        } finally {
            this.loading = false;
            this.isDone = true;
        }
    },
    async addProduct(productId, productType) {
        this.loading = true;
        try {
            const response = await fetch(`/umbraco/surface/cartsurface/AddProduct`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...window.getVerificationToken()
                },
                body: JSON.stringify({
                    'productId': productId,
                    'productType': productType
                }),
            });

            if (response.status === 200) {
                const data = await response.json();
                this.productAdded = true;
                this.transformCart(data);
                Alpine.store('miniBasket', 'mini')

            } else {
                console.log('No data')
            }
        } catch (error) {
            console.log(error)
        } finally {
            this.loading = false;
            this.isDone = true;
        }
    },
    async changePaymentMethod() {
        this.loading = true;
        try {
            const response = await fetch(`/umbraco/surface/cartsurface/ChangePaymentMethod`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...window.getVerificationToken()
                },
                body: JSON.stringify({
                    paymentMethodId: this.optionFinanced
                }),
            });

            if (response.status === 200) {
                const data = await response.json();
                this.transformCart(data);
            } else {
                console.log('No data')
            }
        } catch (error) {
            console.log(error)
        } finally {
            this.loading = false;
            this.isDone = true;
        }
    },
    async UpdateEnvironmentalReturn() {
        this.loading = true;
        try {
            const response = await fetch(`/umbraco/surface/cartsurface/UpdateEnvironmentalReturn`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...window.getVerificationToken()
                },
                body: JSON.stringify({
                    hasEnvironmentalReturn: this.hasChosenEnvironmentalReturn 
                }),
            });

            if (response.status === 200) {
                const data = await response.json();
                this.transformCart(data);
            } else {
                console.log('No data')
            }
        } catch (error) {
            console.log(error)
        } finally {
            this.loading = false;
            this.isDone = true;
        }
    },
    transformCart(data) {
        this.cartEmpty = data.isEmpty;
        this.orderlines = data.orderLines;
        this.accessories = data.accessories;
        this.insurance = data.insurance;
        this.address = data.address;
        this.maxAmountExceeded = data.isMaxAmountExceeded;
        this.optionFinanced = data.paymentMethodId;
        this.financedResult = data.financedResult;
        this.totalPriceCashFormatted = data.totalPriceCashFormatted;
        this.totalSpecialFeeFormatted = data.totalSpecialFeeFormatted;
        this.environmentalReturn = data.environmentalReturn;
        this.salesMode = data.isInternSalesMode;
        this.deliveryType = data.deliveryType;
        this.isAllOrderLinesAccessory = data.isAllOrderLinesAccessory;
        this.hasAtLeastOneProductWithEnvironmentalReturn = data.hasAtLeastOneProductWithEnvironmentalReturn;
        this.hasChosenEnvironmentalReturn = data.hasChosenEnvironmentalReturn;
    },
};

export default cartHandler;